/*
*
* File JS componente Block Hero Slider
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css';
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

import cardCatalog from 'components/cards/card-catalog/card-catalog';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-catalogs-slider.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const catalogsSlider = () =>
{
    let allCatalogsSlider = document.querySelectorAll('.catalogs-slider__slider');
    if(!allCatalogsSlider.length) return;
    
    allCatalogsSlider.forEach(el => {
        
        //let arrowPrev = el.querySelector('.swiper-button-prev');
        //let arrowNext = el.querySelector('.swiper-button-next');

        let pagination = el.querySelector('.swiper-pagination');

        let args =
        {
            slidesPerView: 3,
            spaceBetween: 40,
            speed: 600,
            centerInsufficientSlides: true,
            breakpoints:
            {
                // is >= 0px - Mobile
                0:
                {
                  slidesPerView: 'auto',
                  spaceBetween: 20
                },
                // is >= 768px - Tablet
                768:
                {
                  slidesPerView: 2,
                  spaceBetween: 30
                },
                // is >= 1024px - Desktop
                1024:
                {
                  slidesPerView: 3,
                  spaceBetween: 40
                }
            },
            pagination: {
                el: pagination,
                clickable: true
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };

        new Swiper(el, args);
    })
}

export default catalogsSlider;

//--------------------------------------------------------------------//